import './InlineMessage-80d97643.css';

var classes = {"InlineMessage":"prc-InlineMessage-InlineMessage-Ungod","InlineMessageIcon":"prc-InlineMessage-InlineMessageIcon-RkPyq"};

export { classes as default };
